export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";